module.exports = __webpack_public_path__ + "img/geiger.3bf5502f.png";